import React, { useEffect, FC, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { connect } from "react-redux";

import {
  Form,
  Input,
  Button,
  message,
  Row,
  Col,
  Select,
  Cascader,
  Modal,
} from "antd";
import { LockOutlined, UserOutlined } from "@ant-design/icons";

import "./index.less";
import axios from "@/axios/axios";
import { useGetRandomCode } from "@/hook/randomCode";
import Base64 from "base-64";
import * as actions from "@/store/actions";
import { ItemTitleTypeEnum } from "@/common/data";
import { log } from "console";
import { nationList } from "@/common/nation";
const { Option } = Select;
const { Search } = Input;

const UpdateUserInfo: FC<any> = ({ history, userInfo, setUserInfo }) => {
  // 前端组件学科反显数组
  let selectKey: number[] = [];
  // 初始化的学科列表
  let initSubjectList: never[] = [];
  const [form] = Form.useForm();
  const [unitForm] = Form.useForm();
  const [cityMap, setCityMap] = useState([]);
  const [unitList, setUnitList] = useState([]);
  const [subjectList, setSubjectList] = useState([]);
  const [addUnit, setAddUnit] = useState(false);
  const [randomImgUrl, getRandomImgFn] = useGetRandomCode<string>("");
  const [selectUnit, setSelectUnit] = useState<any>([]);
  let findSubjectArr: Number[] = [];
  // 触发登录方法
  const onFinish = (value: any): void => {
    const {
      department,
      gender,
      idCard,
      area,
      idType,
      instituteId,
      mobile,
      realName,
      smsCode,
      subjectId,
      titleId,
      nativeCode,
      residentCode,
      nation,
    } = value;
    const [nativeProvinceCode, nativeCityCode, nativeDistrictCode] = nativeCode;
    const [residentProvinceCode, residentCityCode, residentDistrictCode] =
      residentCode;
    const [provinceCode, cityCode, districtCode] = area;
    confirm({
      department,
      gender,
      idCard,
      idType,
      instituteId,
      mobile,
      realName,
      smsCode,
      subjectId: subjectId.pop(),
      titleId,
      provinceCode,
      cityCode,
      districtCode,
      /**民族 */
      nation,
      /**籍贯 */
      nativeProvinceCode,
      nativeCityCode,
      nativeDistrictCode,
      /**户口所在地 */
      residentProvinceCode,
      residentCityCode,
      residentDistrictCode,
    });
  };
  const layout = {
    labelCol: {
      span: 6,
    },
    wrapperCol: {
      span: 16,
    },
  };
  const confirm = async (params: any) => {
    const { code, msg }: any = await axios.post(
      "/user/api/ce/user/base/info/save",
      params
    );
    if (code == 0) {
      message.success("更新信息成功");
      history.push("/index/home");
    } else {
      message.error(msg);
    }
  };
  const sendSmsCode = async (params: any) => {
    const { code, msg }: any = await axios.post(
      "/user/api/ce/send/online/sms/code",
      params
    );
    if (code === 0) {
      message.info("已发送验证码，请注意查收");
    } else {
      message.error(msg);
      getRandomImgFn();
    }
  };
  const smsCode = () => {
    const { mobile, verifyCode } = form.getFieldsValue();
    const smsTitle = "医视界";
    console.log(mobile, verifyCode, "-----------------------------");
    sendSmsCode({
      mobile: Base64.encode(mobile),
      smsTitle,
      verifyCode: Base64.encode(verifyCode),
    });
  };
  /**获取城市列表 */
  const getCityList = async () => {
    const { data } = await axios.post("/main/region/getRegionCascadeList");
    setCityMap(data);
  };
  /**根据区获取工作单位 */
  const getUnitByProvinceCode = async (districtCode: string) => {
    const { data } = await axios.post("/main/api/institute/list", {
      systemLevel: 3,
      districtCode,
    });
    data.forEach((item: any) => {
      item.label = item.children;
    });
    setUnitList(data);
  };
  const deepHandleSubjectList = (data: any) => {
    return data.map((item: any) => {
      return {
        label: item.title,
        value: item.key,
        children: item.children.length
          ? deepHandleSubjectList(item.children)
          : [],
      };
    });
  };
  const getSubjectList = async (subjectId: number) => {
    const { data } = await axios.post("/shop/front/ce/subject/list");
    initSubjectList = data;
    setSubjectList(deepHandleSubjectList(data));
    deepFindKey(subjectId, initSubjectList as any);
  };
  /**获取基本的用户信息 */
  const getBaseUserInfo = async () => {
    const { data } = await axios.post("/user/api/ce/user/base/info/view");
    const {
      provinceCode,
      cityCode,
      districtCode,
      instituteId,
      nativeProvinceCode,
      nativeCityCode,
      nativeDistrictCode,
      residentProvinceCode,
      residentCityCode,
      residentDistrictCode,
      subjectId,
    } = data;
    getUnitByProvinceCode(districtCode);
    form.setFieldsValue({
      ...data,
      area:
        provinceCode && cityCode && districtCode
          ? [provinceCode, cityCode, districtCode]
          : [],
      instituteId: instituteId,
      /**籍贯 */
      nativeCode: [nativeProvinceCode, nativeCityCode, nativeDistrictCode],
      /**户口所在地 */
      residentCode: [
        residentProvinceCode,
        residentCityCode,
        residentDistrictCode,
      ],
    });
    // 获取学科分类
    getSubjectList(subjectId);
  };
  /**遍历查询父级的key */
  const deepFindKey = (findKey: number, subjectListChildren: []) => {
    subjectListChildren.forEach((item: any) => {
      //找到当前的选项了
      if (item.key === findKey) {
        selectKey.unshift(findKey);
        // 如果当前有parentId;
        if (item.parentId) {
          deepFindKey(item.parentId, initSubjectList as any);
        }
        //递归children
      } else {
        item.children.length && deepFindKey(findKey, item.children);
      }
    });
    form.setFieldsValue({
      subjectId: selectKey,
    });
  };

  const submitUnit = (val: any) => {
    const { area, instituteName } = val;
    axios
      .post("/user/api/ce/item/institute/apply/save", {
        cityCode: area[1],
        districtCode: area[2],
        provinceCode: area[0],
        instituteName,
        region:
          selectUnit[0].label +
          "/" +
          selectUnit[1].label +
          "/" +
          selectUnit[2].label,
      })
      .then((res: any) => {
        if (res.code === 0) {
          message.success("提交成功");
          setAddUnit(false);
          unitForm.resetFields();
          setSelectUnit([]);
        }
      });
  };
  /**
   * 通过用户信息进行全省搜索
   * @param instituteName
   */
  const searchInsitFromProvince = async (instituteName: string) => {
    const area = form.getFieldValue("area");
    const provinceCode = area[0];
    const { data } = await axios.post("/main/api/institute/list", {
      instituteName,
      provinceCode,
      systemLevel: 3,
    });
    setUnitList(data);
  };
  useEffect(() => {
    getCityList();
    getBaseUserInfo();
  }, []);

  const FormView = (
    <Form
      form={form}
      {...layout}
      className="login-form"
      name="login-form"
      onFinish={onFinish}
    >
      <Form.Item>
        <h3 style={{ textAlign: "center" }}>补充信息</h3>
      </Form.Item>
      <Form.Item
        label="手机号"
        name="mobile"
        rules={[{ required: true, message: "请输入手机号" }]}
      >
        <Input placeholder="请输入手机号" size="large" disabled />
      </Form.Item>
      <Form.Item
        label="姓名"
        name="realName"
        rules={[{ required: true, message: "真实姓名" }]}
      >
        <Input placeholder="请输入真实姓名" size="large" />
      </Form.Item>
      <Form.Item
        label="性别"
        name="gender"
        rules={[{ required: true, message: "请选择性别" }]}
      >
        <Select placeholder="请选择性别">
          <Option value={1}>男</Option>
          <Option value={2}>女</Option>
        </Select>
      </Form.Item>
      <Form.Item
        label="民族"
        name="nation"
        rules={[{ required: true, message: "请选择民族" }]}
      >
        <Select placeholder="请选择民族">
          {nationList.map((item) => (
            <Option value={item}>{item}</Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item
        label="籍贯"
        name="nativeCode"
        rules={[{ required: true, message: "请选择籍贯" }]}
      >
        <Cascader options={cityMap} placeholder="请选择籍贯" />
      </Form.Item>
      <Form.Item
        label="户口所在地"
        name="residentCode"
        rules={[{ required: true, message: "请选择户口所在地" }]}
      >
        <Cascader options={cityMap} placeholder="请选择户口所在地" />
      </Form.Item>
      <Form.Item
        name="idType"
        label="证件类型"
        rules={[{ required: true, message: "请选择证件类型" }]}
      >
        <Select placeholder="请选择证件类型">
          <Option value={1}>居民身份证</Option>
          <Option value={2}>护照/港澳通行证</Option>
          <Option value={3}>军官证</Option>
        </Select>
      </Form.Item>
      <Form.Item
        name="idCard"
        label="证件号"
        rules={[{ required: true, message: "请输入证件号" }]}
      >
        <Input placeholder="请输入证件号" size="large" />
      </Form.Item>
      <Form.Item
        name="area"
        label="单位地区"
        rules={[{ required: true, message: "请选择单位地区" }]}
      >
        <Cascader
          options={cityMap}
          placeholder="请选择单位地区"
          onChange={(value) => {
            if (value) {
              const [provinde, city, districtCode] = value;
              form.setFieldsValue({
                instituteId: "",
                instituteName: "",
              });
              console.log(value);
              getUnitByProvinceCode(districtCode as string);
            }
          }}
        />
      </Form.Item>
      <Form.Item shouldUpdate={(prev, cur) => prev.area !== cur.area} noStyle>
        {() => {
          let area = form.getFieldValue("area");
          if (area && area.length > 0) {
            return (
              <div className={"mySelect"}>
                <Form.Item
                  name="instituteId"
                  label="工作单位"
                  rules={[{ required: true, message: "请选择工作单位" }]}
                  hidden={true}
                >
                  <Select placeholder="请选择工作单位">
                    {unitList.map((item: any) => (
                      <Option key={item.id} value={item.instituteId}>
                        {item.instituteName}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item
                  name="instituteName"
                  label="工作单位"
                  rules={[{ required: true, message: "请选择工作单位" }]}
                >
                  <Select
                    placeholder="请选择工作单位"
                    showSearch
                    filterOption={(input, option) =>
                      option?.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    onSearch={(value) => {
                      searchInsitFromProvince(value);
                    }}
                    onSelect={(value) => {
                      form.setFieldsValue({
                        instituteId: value,
                      });
                    }}
                  >
                    {unitList.map((item: any) => (
                      <Option key={item.id} value={item.instituteId}>
                        {item.instituteName}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
                <span
                  onClick={() => {
                    setAddUnit(true);
                  }}
                >
                  没有单位，点击上报
                </span>
              </div>
            );
          } else {
            return null;
          }
        }}
      </Form.Item>
      <Form.Item
        name="department"
        label="科室"
        rules={[{ required: true, message: "请输入科室" }]}
      >
        <Input placeholder="请输入科室" size="large" />
      </Form.Item>
      <Form.Item
        name="titleId"
        label="职称"
        rules={[{ required: true, message: "请选择职称" }]}
      >
        <Select placeholder="请选择职称">
          {ItemTitleTypeEnum.map((item) => (
            <Option key={item.value} value={item.value}>
              {item.name}
            </Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item
        name="subjectId"
        label="所属学科"
        rules={[{ required: true, message: "请选择所属学科" }]}
      >
        <Cascader options={subjectList} placeholder="请选择所属学科" />
      </Form.Item>
      <Form.Item
        name="verifyCode"
        label="图形验证码"
        rules={[{ required: true, message: "请输入图形验证码" }]}
      >
        <Input
          placeholder="请输入图形验证码"
          suffix={
            <img
              src={randomImgUrl}
              alt="code"
              onClick={() => {
                getRandomImgFn();
              }}
              style={{ width: "100px", height: "100%" }}
            />
          }
        />
      </Form.Item>
      <Form.Item
        name="smsCode"
        label="手机验证码"
        rules={[{ required: true, message: "请输入验证码!" }]}
      >
        <Search
          placeholder="请输入验证码"
          allowClear
          enterButton="获取验证码"
          size="large"
          onSearch={smsCode}
        />
      </Form.Item>
      <div style={{ textAlign: "center", width: "100%" }}>
        <Button style={{ marginRight: "20px" }}>
          <Link to="/index/home">返回</Link>
        </Button>
        <Button htmlType="submit" type="primary">
          提交
        </Button>
      </div>
      <div style={{ textAlign: "center", marginTop: "20px" }}>
        <p>客服电话: 400-001-8080</p>
      </div>
    </Form>
  );
  return (
    <div className="userInfo-box" id="login-layout">
      <div className="login-box">
        <div className="logo-name">医视界 | 远程继续医学教育平台</div>
        <div className={"login-form-box"}>{FormView}</div>
        <Modal
          open={addUnit}
          title="单位上报"
          footer={null}
          onCancel={() => {
            unitForm.resetFields();
            setAddUnit(false);
          }}
        >
          <Form form={unitForm} onFinish={submitUnit}>
            <Form.Item
              label="工作单位"
              name="instituteName"
              rules={[{ required: true, message: "请输入工作单位" }]}
            >
              <Input placeholder="工作单位"></Input>
            </Form.Item>
            <Form.Item
              label="单位地址"
              name="area"
              rules={[{ required: true, message: "请选择单位地区" }]}
            >
              <Cascader
                options={cityMap}
                placeholder="请选择单位地区"
                onChange={(val, selectedOptions: any) => {
                  setSelectUnit(selectedOptions);
                  unitForm.setFieldsValue({
                    area: val,
                  });
                }}
              />
            </Form.Item>
            <p style={{ textAlign: "center" }}>
              单位需要人工审核，请等待48小时后再来补充信息
            </p>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button type="primary" htmlType="submit">
                确认
              </Button>
            </div>
          </Form>
        </Modal>
      </div>
    </div>
  );
};

export default connect((state) => state, actions)(UpdateUserInfo);
